// extracted by mini-css-extract-plugin
module.exports = {"container":"Wedge-module--container--1TSGV","wedge":"Wedge-module--wedge--1vy6D"};